<div class="db-single-page-payout">
    <div class="db-single-page-payout__header">
        <div class="route-container">
            <span class="mr6" [routerLink]="['/payments-management']">{{ 'text_paymentManagement' | dbText }}</span>
            <i class="db-icon db-icon-ds-arrow-right"></i>
            <div class="merchant-id">
                <span>{{activeMerchant?.merchant_id}}</span>
            </div>
        </div>
        <!--<span class="total-amount">Pending Payouts: ${{payoutsAmount}}</span>-->
    </div>
    <div class="db-single-page-payout__content mt30">
        <div class="db-single-page-payout__table mt20">
            <pay-engine
                    id="pf-single-payouts"
                    type="payouts"
                    hideFilter
                    css="#payengine-payouts-style"
            ></pay-engine>
        </div>
    </div>
</div>
<db-loading-screen *ngIf="!!loading" [pageBlocker]="true"></db-loading-screen>
